declare global {
    interface Window {
        fbq: ((...args: any[]) => void) & { callMethod?: (...args: any[]) => void; queue: any[]; push: (...args: any[]) => void; loaded: boolean; version: string }
    }
}

export const useMetaPixel = () => {
    const route = useRoute()
    const cookieControl = useCookieControl()

    // Skip tracking for admin and internal pages
    const excludedPaths = ['/admin', '/growni']
    const isExcluded = excludedPaths.some(path => route.path.startsWith(path))
    if (isExcluded) return

    const enablePixel = () => {
        if (typeof window === 'undefined' || !window.fbq) return
        window.fbq('consent', 'grant')
    }

    const disablePixel = () => {
        if (typeof window === 'undefined' || !window.fbq) return
        window.fbq('consent', 'revoke')
    }

    // Check initial state
    if (cookieControl.cookiesEnabledIds.value?.includes('marketing')) {
        enablePixel()
    } else {
        disablePixel()
    }

    // Watch for consent changes
    watch(cookieControl.cookiesEnabledIds, (current, previous) => {
        const wasEnabled = previous?.includes('marketing')
        const shouldBeEnabled = current?.includes('marketing')

        if (wasEnabled === shouldBeEnabled) {
            return
        }

        if (shouldBeEnabled) {
            enablePixel()
        } else {
            disablePixel()
        }
    })
}
